<template>
    <div id="Console">
        <el-card shadow="never">
            <el-row>
                <el-col :span="16">
                    <el-button-group>
                        <el-button type="info" @click="reportoryDetail()" icon="el-icon-refresh">刷新</el-button>
                        <el-button @click="affirm()" type="info">调整</el-button>
                    </el-button-group>   
                </el-col>
                <el-col :span="6" class="serch-input" style="float:right;">
                    <el-input placeholder="请输入类型名称" v-model="input5" class="input-with-select" clearable>
                    </el-input>
                </el-col>  
            </el-row>  
             <el-row class="con-table">
                <el-col :span="24">
                    <el-table
                        v-loading="loading"
                        element-loading-text="努力加载中"
                        element-loading-spinner="el-icon-loading"
                        max-height="340"
                        :data = "tableData2.filter(data => !input5 || data.typeName.toLowerCase().includes(input5.toLowerCase()))"
                        :summary-method="getSummaries"  
                        show-summary
                        border
                        style="width:100%"
                    >
                        <el-table-column
                            prop="typeName"
                            label="类型"
                            header-align="center"
                            align="left"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="addQty"
                            label="调整数量"
                            header-align="center"
                            align="right"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="saleQty"
                            label="销售数量"
                             header-align="center"
                             align="right"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="checkQty"
                            label="核销数量"
                             header-align="center"
                             align="right"
                        >
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .serch-input{
        float:right;
    }
    .select-state{
        margin-left: 10px;
    }
    .con-table{
        margin-top: 20px;
    }
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import {getToken } from '@/env/util'
export default {
    mixins:[requestMixin,common],
    data(){
        return {
            tableData2:[],
            value: '',
            input5:'',
            loading: false,
            amount:'',
            unAmount:'',
        }
    },
    mounted(){
        getToken();
        this.reportoryDetail();
    },
    methods:{
        //调整
        affirm(){
            this.$router.push({
                path:'/market/adjustmentStock'
            })
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                const values = data.map(item =>{
                    return Number(item[column.property].toString().replace(/,/g, ""))
                    
                    });
                // console.log(values)
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] = this.changeTree(sums[index]);
                } else {
                    sums[index] = '';
                }
                });
                return sums;
        },
        //刷新
        reportoryDetail(){
            let that = this ;
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act : 'repertoryDetailByGroup',
                userId
            }
            that.delType(params).then((res) => {
                let { status } = res.data ;
                that.loading = true ;
                if(status == true){
                    let { report } = res.data ;
                    that.loading = false ;
                    report.forEach((elem) => {
                        elem.onhandQuantity = that.changeTree(Math.trunc(elem.onhandQuantity))
                    })
                    that.tableData2 = report ;
                }else{
                    that.loading = false ;
                    that.alert('加载失败!','warning')
                }
            })
        }
    }
}
</script>
